import { Component, Input } from '@angular/core';

@Component({
    selector: 'tcm-tooltip',
    templateUrl: './tcm-tooltip.component.html',
    styleUrls: ['./tcm-tooltip.component.scss'],
    standalone: false
})
export class TcmTooltipComponent {
  @Input() triggers: string;
  @Input() placement: string;

  constructor() { }

}
